import { useEffect } from 'react';
import { UBER_URL, DELIVEROO_URL } from '../constants';
import Header from '../components/Header';
import Footer from '../components/Footer';


const HOURS = [
  { day: 'Lundi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Mardi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Mercredi', hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Jeudi',    hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Vendredi', hours: '11h00 – 14h00  ·  18h00 – 23h00' },
  { day: 'Samedi',   hours: '18h00 – 23h00' },
  { day: 'Dimanche', hours: '18h00 – 22h00' },
];

const TODAY_INDEX = [6, 0, 1, 2, 3, 4, 5][new Date().getDay()];

export default function Localisation() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Notre Emplacement — Four A Tacos';
  }, []);


  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      {/* Bannière */}
      <div className="hero-banner hero-banner-auto" style={{ backgroundColor: '#C10230', padding: 'calc(80px + 60px) 24px 60px' }}>
        <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px', textAlign: 'center' }}>
          <h1 className="hero-title" style={{ margin: 0 }}>
            Notre emplacement
          </h1>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=303+Rue+de+la+République+73000+Chambéry"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '600', color: '#fff', backgroundColor: 'transparent', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '1px', border: '2px solid #fff' }}
            >
              Itinéraire
            </a>
            <a
              href={DELIVEROO_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', borderRadius: '8px', border: '2px solid #fff', textDecoration: 'none' }}
            >
              <img src="/deliveroo.png" alt="Deliveroo" style={{ height: '22px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
            </a>
            <a
              href={UBER_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', padding: '10px 20px', borderRadius: '8px', border: '2px solid #fff', textDecoration: 'none' }}
            >
              <img src="/uber.png" alt="Uber Eats" style={{ height: '22px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
            </a>
          </div>
        </div>
      </div>

      {/* Section 3 colonnes */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="localisation-grid" style={{ width: '100%' }}>

        {/* Horaires */}
        <div className="localisation-col-1">
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 24px 0' }}>
            Heures d'ouverture
          </p>
          {HOURS.map(({ day, hours }, i) => {
            const isToday = i === TODAY_INDEX;
            return (
            <div key={day} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', width: '100%' }}>
              <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: isToday ? '700' : '400', color: isToday ? '#000' : '#555' }}>
                {day}
              </span>
              <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: isToday ? '700' : '400', color: isToday ? '#000' : '#555' }}>
                {hours}
              </span>
            </div>
            );
          })}
        </div>

        {/* Contact */}
        <div className="localisation-col-2">
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 24px 0' }}>
            Contact
          </p>
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#4A4A4A', lineHeight: '1.8', margin: '0 0 16px 0' }}>
            303 Rue de la République<br />
            73000 Chambéry
          </p>
          <a href="tel:0422910537" style={{ display: 'block', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '600', color: '#C10230', textDecoration: 'none', marginBottom: '8px' }}>
            04 22 91 05 37
          </a>
          <a href="tel:0621961492" style={{ display: 'block', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '600', color: '#C10230', textDecoration: 'none', marginBottom: '32px' }}>
            06 21 96 14 92
          </a>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=303+Rue+de+la+République+73000+Chambéry"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '600', color: '#000', backgroundColor: 'transparent', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '1px', border: '2px solid #000', display: 'inline-block' }}
          >
            Itinéraire
          </a>
        </div>

        {/* Carte Google Maps */}
        <div className="localisation-col-3">
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 24px 0' }}>
            Nous trouver
          </p>
          <iframe
            title="Four a Tacos Chambéry"
            src="https://maps.google.com/maps?q=303+Rue+de+la+R%C3%A9publique+Chamb%C3%A9ry&output=embed&z=16"
            width="100%"
            height="280"
            style={{ border: 'none', borderRadius: '8px', display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

      </div>
      </div>

      <Footer />
    </div>
  );
}
